/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fundingyear1Inputs */

const de__field_fundingyear1 = /** @type {(inputs: _Field_Fundingyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förderjahr`)
};

/**

* @param {_Field_Fundingyear1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fundingyear1 = /** @type {((inputs?: _Field_Fundingyear1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fundingyear1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_fundingyear1(inputs)
});
export { _field_fundingyear1 as "_field_fundingYear" }